interface DividerProps {
  className?: string
}

export function Divider({ className = '' }: DividerProps) {
  return <div className={`h-px bg-gray-200 w-full ${className}`} />
}
